<template>
    <button
        v-if="!href"
        :type="type"
        :form="form"
        :disabled="disabled"
        class="def-button-secondary"
    >
        <slot />
    </button>
    <a
        v-else
        :href="href"
        :rel="rel"
        class="def-button-secondary"
    >
        <slot />
    </a>
</template>

<script>
export default {
    name: 'DefButtonSecondary',
    selector: '.def-button-secondary',
    props: {
        type: {
            type: String,
            default: 'button',
        },
        href: {
            type: String,
        },
        form: String,
        rel: String,
        disabled: Boolean,
    },
}
</script>

<style lang="scss" scoped>
.def-button-secondary{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    background-color: transparent;
    border: 1px solid var(--background-black);
    font-weight: 600;
    font-size: rem(10);
    line-height: 100%;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    transition: .2s linear background-color;
    padding: 0 15px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    border-radius: rem(8);
    &:hover{
        background-color: #3c3d41;
        color: white;
    }
    &:disabled{
        border-color: var(--border-grey);
        pointer-events: none;
        color: #5F5F67;
        //cursor: not-allowed;
    }
}
</style>